import script from "./MyAppointment.vue?vue&type=script&setup=true&lang=js"
export * from "./MyAppointment.vue?vue&type=script&setup=true&lang=js"

import "./MyAppointment.vue?vue&type=style&index=0&id=14d52cc2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14d52cc2"]])

export default __exports__